import { getModalByUrl, openModalFromHtml } from './utilities/modal';
import { getForm, resetFormFields } from './utilities/form';

/**
 * BaseController::modalConfirm(): show the confirmation modal; on accept re-submit the
 * originating form to the same URL with confirmed=1
 */
async function handleConfirmAction(action, element) {
    // capture the URL now — another button may point the form elsewhere while the modal is open
    const form = element instanceof HTMLFormElement ? getForm(element) : undefined;
    const url = form?.url;

    const params = new URLSearchParams({
        message: action.message || '',
        buttonText: action.buttonText || '',
        cancelText: action.cancelText || '',
    });
    const modalController = await getModalByUrl(`${action.url}${action.url.includes('?') ? '&' : '?'}${params.toString()}`);

    if (!modalController) {
        return;
    }

    modalController.element.addEventListener('modal:confirm', () => {
        if (form) {
            form.setUrl(url).submit(undefined, { confirmed: 1 }).catch(() => {
                // validation/request errors are rendered by the form itself
            });
        }
    }, { once: true });

    modalController.open();
}

async function handleAction(action, element = undefined) {
    if (action.action === 'confirm') {
        await handleConfirmAction(action, element);
    } else if (action.action === 'openModalUrl') {
        const modalController = await getModalByUrl(action.url + `&message=${action.message}&buttonText=${action.buttonText}&reload=${action.reload}`);

        if (modalController) {
            modalController.open();
            if (action.resetFields) {
                resetFormFields(document);
            }
        }
    } else if (action.action === 'openModalHtml') {
        const modalController = await openModalFromHtml(action.html);

        modalController?.open();
    } else if (action.action === 'resetFields') {
        resetFormFields(element);
    } else if (action.action === 'reload') {
        window.location.reload();
    } else if (action.action === 'redirect') {
        window.location.assign(action.url);
    } else {
        console.error(`Unknown action: ${action.action}`);
    }
}

export {
    handleAction,
};
